// 嵌套结构 — 与组件中的 t('list.title') / t('createTournament.basicInfo.title') 等用法对齐
export const tournament = {
  // ---------------- 锦标赛列表页 ----------------
  list: {
    title: "锦标赛",
    totalTournaments: "共 {{count}} 场锦标赛",
    new: "新建",
    getStarted: "开始",
    createNew: "创建新锦标赛",
    setupFormat: "设置淘汰赛或循环赛格式",
    createTournament: "创建锦标赛",
    noTournaments: "没有合适的锦标赛？",
    noFilteredTournaments: "暂无{{filter}}的锦标赛",
    noFilteredDescription: "目前没有任何{{filter}}的锦标赛。",
    createFirst: "试试搜索其他城市，或者自己创建一场。",
    deleteConfirm: "确定要删除此锦标赛吗？",
    progress: "进度",
    matches: "{{completed}} / {{total}} 场",
    created: "创建于",
    view: "查看",
    noLocation: "未设地点",
    singleElimination: "单淘汰赛",
    roundRobin: "循环赛",
    players: "{{count}} 名选手",
    filter: {
      all: "全部",
      active: "进行中",
      completed: "已完成",
    },
    status: {
      upcoming: "即将开始",
      open: "报名中",
      inProgress: "进行中",
      completed: "已完成",
      cancelled: "已取消",
    },
  },

  // ---------------- 创建锦标赛页 ----------------
  createTournament: {
    title: "创建锦标赛",
    subtitle: "设置一场新的锦标赛",
    nextStep: "下一步：添加参赛者",
    publishCta: "创建并发布",
    rankedTitle: "Acework 积分赛",
    rankedSubtitle: "标记为 Acework 积分赛，胜场会计入官方评级和城市排行榜。",
    rankedToggle: "Acework 积分锦标赛",
    rankedHint: "胜场需双方确认后按水平累计积分。",
    proOnly: "Pro+",

    basicInfo: {
      title: "基本信息",
      name: "锦标赛名称",
      namePlaceholder: "例如：2026 春季锦标赛",
      location: "地点",
      locationPlaceholder: "例如：中心公园网球俱乐部",
      date: "开始日期",
    },

    format: {
      title: "锦标赛格式",
      type: "格式类型",
      elimination: "单淘汰赛",
      eliminationDesc: "淘汰制",
      roundRobin: "循环赛",
      roundRobinDesc: "小组赛",
      drawSize: "抽签规模",
      groupSize: "参赛总人数",
      numberOfSeeds: "种子选手数",
      seedsInfo: "1 号和 2 号种子将被放在抽签的不同半区。",
    },

    matchSettings: {
      title: "比赛设置",
      category: "比赛项目",
      categories: {
        mens_singles: "男单",
        womens_singles: "女单",
        mens_doubles: "男双",
        womens_doubles: "女双",
        mixed_doubles: "混双",
        rally: "拉球",
        group: "群约 · 不限人数",
      },
      matchFormat: "比赛长度",
      bestOf1: "一盘",
      bestOf3: "三盘两胜",
      bestOf5: "五盘三胜",
      gamesPerSet: "每盘局数",
      gamesPerSetHint: "标准盘制为先得 6 局。4 局制在俱乐部和业余比赛中很常见。抢十 = 用一个抢十决胜整场。",
      games6: "先得 6 局",
      games4: "先得 4 局",
      gamesTiebreak: "抢十",
      deuceRule: "平分规则（40-40）",
      deuceRuleHint: "金球制：平分后下一分立即决出胜负。优势制：需赢 2 分。",
      deuce: {
        advantage: "优势",
        goldenPoint: "金球",
      },
      tiebreak: "抢七制",
      points7: "先得 7 分",
      points10: "先得 10 分",
    },

    summary: {
      title: "锦标赛摘要",
      subtitle: "查看你的设置",
      name: "名称",
      notSet: "未设置",
      format: "格式",
      drawSize: "抽签规模",
      groupSize: "总人数",
      players: "名选手",
      seededPlayers: "种子选手",
      seeds: "个种子",
      matchFormat: "比赛格式",
      bestOf: "最多",
      tiebreak: "抢七",
      points: "分",
    },

    participants: {
      title: "添加参赛者",
      players: "名选手",
      seeds: "个种子",
      addPlayer: "搜索选手",
      searchHint: "只有注册的 Acework 用户可以参赛。按账号或姓名搜索。",
      searchPlaceholder: "按 @账号 或 姓名 搜索…",
      addBye: "添加轮空（获胜晋级）",
      makeSeed: "设为种子",
      unseed: "取消种子",
      seededPlayers: "种子选手",
      seedNumber: "第 {{number}} 号种子",
      unseededPlayers: "非种子选手",
      walkover: "轮空",
      noParticipants: "上方搜索以添加选手。只能添加注册用户。",
      backToSettings: "返回设置",
      createTournament: "创建锦标赛",
    },

    validation: {
      nameRequired: "锦标赛名称是必需的",
      maxPlayers: "此抽签规模最多允许 {{max}} 名选手",
      maxSeeds: "最多允许 {{max}} 个种子选手",
      minParticipants: "请至少添加 2 名参赛者",
      allSeeds: "请先添加全部 {{required}} 个种子选手",
      loginRequired: "请登录以创建锦标赛",
      rankedPaidOnly: "Acework 积分赛是 Pro / Elite 功能。升级以举办积分赛。",
      rankedDrawTooBig: "你的等级支持最多 {{cap}} 人的 Acework 积分赛。升级至精英版以支持更大规模。",
    },
  },

  // ---------------- 锦标赛括号页 ----------------
  bracket: {
    title: "锦标赛括号",
    progress: "锦标赛进度",
    champion: "冠军",
    tournamentChampion: "锦标赛冠军",
    playerDraw: "球员抽签",
    matchDetails: "比赛详情",
    bestOfSets: "最多",
    sets: "盘",
    diagram: "锦标赛括号图",
    round: "轮次",
    final: "决赛",
    semifinals: "半决赛",
    quarterfinals: "四分之一决赛",
    winner: "胜者",
    draw: "抽签",
    format: "格式",
    roundRobinFormat: "循环赛格式",
    allMatches: "所有比赛",
    tapToEnterScore: "点击输入比分",
    completeRoundAdvance: "完成轮次并晋级",
    advance: "晋级",
  },

  // ---------------- 锦标赛历史页 ----------------
  history: {
    title: "锦标赛历史",
    viewAll: "查看所有锦标赛",
    notFound: "未找到锦标赛",
  },

  // ---- 顶级快捷键 ----
  // 一些 UI 元素（芯片、按钮）直接调用这些。
  tournaments: "锦标赛",
  matches: "场",
  cancel: "取消",
  live: "直播",
};
